// 通用的 props 属性
export const size = {
  type: String,
  default: '',
  validator(val) {
    return ['medium', 'small', 'mini'].includes(val);
  }
};
